import { Component } from "react";
import { Button, CloseButton, Col, ListGroup, ListGroupItem, Modal, Offcanvas, Row, Stack, Container } from "react-bootstrap";
import { AppApiManager } from "../util/appApiManager";
import { TemplateBuilder } from "../components/templateBuilder";
import { downloadFile } from "../util/downloadHelper";
import { SubjectsTable } from "../components/subjectsTable";
import keycloak from "../util/keycloak";
import { useKeycloak } from "@react-keycloak/web";

class AdminView extends Component {
    constructor(props) {
        super(props)
        this.state = {
            file: null,
            templates: [],
            createTemplateMode: false,
            viewTemplateMode: false,
        }
        this.apiManager = new AppApiManager()

        this.refreshTemplateList = this.refreshTemplateList.bind(this)
    }

    async refreshTemplateList() {
        const templates = await this.apiManager.getTemplates()
        this.setState({
            templates: [
                ...templates,
            ]
        })
    }
    async componentDidMount() {
        if (!this.apiManager.hasValidAuthToken()) {
            keycloak.login()
            return
        }
        this.refreshTemplateList()
    }

    changeCreateTemplateMode = (show, copyData) => {
        const { _id, ...templateData } = copyData || {}
        this.setState({
            createTemplateMode: show,
            createTemplateCopyData: templateData,
        })
    }

    changeViewTemplateMode = (show, templateData) => {
        this.setState({
            viewTemplateMode: show,
            viewTemplateData: templateData,
        })
    }

    savedTemplate = () => {
        this.changeCreateTemplateMode(false)
        this.refreshTemplateList()
    }

    controlDeleteModal = templateData => {
        this.setState({deleteModalProps: templateData})
    }

    inlineDeleteButton  = templateData => (e) => {
        e.stopPropagation()
        this.controlDeleteModal(templateData)
    }

    templateDelete = template => {
        this.apiManager.deleteTemplate(template._id).then(res => {
            if (res) {
                this.controlDeleteModal(undefined)
                this.refreshTemplateList()
            } else {
                alert('Something went wrong')
            }
        })
    }

    downloadResponses = async (templateId) => {
        try {
            const url = await this.apiManager.downloadFormResponses(templateId)
            if (url) {
                downloadFile(url, 'formResponses.csv')
            }
            
        } catch (e) {
            console.log(e)
        }
    }

    render() {
        return (
            <>
                <Container fluid className="p-4">
                    <Row>
                        <Col xs={12} lg={6}>
                            <h3 className="mt-3">Templates</h3>
                            <ListGroup className="my-3">
                                {this.state.templates.map((template, idx) => 
                                    <ListGroupItem key={idx}>
                                        <Stack className="justify-content-between" direction="horizontal">
                                            <span>{template.templateName}</span>
                                            <Stack direction="horizontal">
                                                <Button className="mx-1" variant="secondary" onClick={() => {this.changeViewTemplateMode(true, template)}}><i class="bi bi-info-circle"></i></Button>
                                                <Button className="mx-1" variant="secondary" onClick={() => {this.downloadResponses(template._id)}}><i class="bi bi-download"></i></Button>
                                                <Button className="mx-1" variant="secondary" onClick={() => {this.changeCreateTemplateMode(true, template)}}><i class="bi bi-copy"></i></Button>
                                                {(this.props.userDomain === 'District' || this.props.userDomain === template.domain) &&
                                                    <CloseButton className="mx-1" onClick={this.inlineDeleteButton(template)} />
                                                }
                                            </Stack>
                                            
                                        </Stack>
                                        
                                    </ListGroupItem>
                                )}
                                {this.state.templates.length === 0 &&
                                    <ListGroupItem>No items in list</ListGroupItem>
                                }
                            </ListGroup>
                            <Button onClick={() => {this.changeCreateTemplateMode(true)}}>Create Template</Button>
                        </Col>
                        
                        <Col xs={12} lg={6}>
                            <SubjectsTable userDomain={this.props.userDomain} apiManager={this.apiManager}/>
                        </Col>
                        
                    </Row>
                </Container>

                {/* Modals and offcanvases */}
                <Modal show={!!this.state.deleteModalProps} onHide={() => {this.controlDeleteModal(undefined)}}>
                    <Modal.Header>
                        <Modal.Title>Are you sure you wish to delete this template?</Modal.Title>
                    </Modal.Header>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => {this.controlDeleteModal(undefined)}}>
                            Cancel
                        </Button>
                        <Button variant="danger" onClick={() => {this.templateDelete(this.state.deleteModalProps)}}>
                            Delete
                        </Button>
                    </Modal.Footer>
                </Modal>
                <Offcanvas show={this.state.createTemplateMode} onHide={() => {this.changeCreateTemplateMode(false)}}>
                    <Offcanvas.Header closeButton>
                        <Offcanvas.Title>Create new template</Offcanvas.Title>
                    </Offcanvas.Header>
                    <Offcanvas.Body>
                        <TemplateBuilder domain={this.props.userDomain} onTemplateSave={this.savedTemplate} templateData={this.state.createTemplateCopyData} apiManager={this.apiManager} />
                    </Offcanvas.Body>
                </Offcanvas>
                <Offcanvas placement="end" show={this.state.viewTemplateMode} onHide={() => {this.changeViewTemplateMode(false, undefined)}}>
                    <Offcanvas.Header closeButton>
                        <Offcanvas.Title>View template</Offcanvas.Title>
                    </Offcanvas.Header>
                    <Offcanvas.Body>
                        <TemplateBuilder domain={this.props.userDomain} viewOnlyMode={true} templateData={this.state.viewTemplateData} />
                    </Offcanvas.Body>
                </Offcanvas>
            </>
        )
    }
}

export const CloakedAdminView = (props) => {
    const { keycloak } = useKeycloak();
    if (!keycloak.authenticated || !keycloak.token) {
        keycloak.login();
    }
    return (<AdminView {...props} userDomain={keycloak.tokenParsed?.userDomain}/>)
}
